{
  "CSAT": {
    "TITLE": "Betygsätt din konversation",
    "PLACEHOLDER": "Berätta mer...",
    "RATINGS": {
      "POOR": "😞 Dåligt",
      "FAIR": "😑 Okej",
      "AVERAGE": "😐 Genomsnittligt",
      "GOOD": "😀 Bra",
      "EXCELLENT": "😍 Utmärkt"
    }
  }
}
